/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PrintQrCodesRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {PrintQrCodesResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const printQrCodes = (request: PrintQrCodesRequest, options?: CashRequestOptions) => post<PrintQrCodesRequest, PrintQrCodesResponse>("/2.0/cash/print-qr-codes", request, {...options, rejectOnError: true })